<template style="touch-action: none;">
  <v-container class="pa-0" fluid style="min-height: 100%; background-image: linear-gradient(to top, #6a85b6 0%, #bac8e0 100%);">
    <v-row class="text-center">
      <v-alert
        v-show="alertShow"
        style="position: absolute;left: 2rem;bottom: 2rem; z-index: 99;"
        class="text-title text-md-h6"
        dense
        v-bind:type="alertType"
      >
        {{ alert }}
      </v-alert>
      <div class="margin-0-auto mt-10 col-sm-12 col-lg-6">
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col class="col-sm-12 col-lg-4">
                  設定打卡提醒時間
                </v-col>
                <v-col
                  class="text--secondary d-none d-sm-none d-md-flex col-lg-8"
                  
                >
                  <v-fade-transition leave-absolute>
                    <span
                      v-if="open"
                      key="0"
                    >
                      
                    </span>
                    <span
                      v-else
                      key="1"
                    >
                      {{ trip.ip }}
                    </span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="d-lg-column" no-gutters>
            <v-col
              class="text--secondary col-12 col-lg-8"
            >
            <v-timeline
              align-top
              dense
            >
              <v-timeline-item
                v-for="(tm,index) in ls_timeline"
                :key="'A'+index"
                :color="tm.color"
                small
              >
                <v-row class="pt-1">
                  <v-col cols="3">
                    <strong>{{ tm.notice }}</strong>
                    
                  </v-col>
                  <v-col cols="6">
                    <strong>{{ tm.title }}</strong>
                    <div class="caption">
                      {{ tm.subtitle }}
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <v-icon @click="chk_del(tm)">mdi-delete</v-icon>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
            </v-col>
            <v-col
              class="text--secondary col-12 col-lg-4"
            >
            <v-menu
              ref="menu"
              v-model="timePicker"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="btime"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="btime"
                  label="選擇提醒時間"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="timePicker"
                v-model="btime"
                format="24hr"
                full-width
                @click:minute="$refs.menu.save(btime)"
              ></v-time-picker>
            </v-menu>
            <!-- <v-text-field
              v-model="btime"
              label="選擇提醒時間"
              prepend-icon="mdi-clock-time-four-outline"
              readonly
              v-bind="attrs"
              @click = "timePicker=true;"
            ></v-text-field>
            <v-time-picker
              format="24hr"
              v-if="timePicker"
              v-model="btime"
              abo
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="timePicker = false"
              >
                確定
              </v-btn>
            </v-time-picker> -->
            <v-text-field
              v-model="timeName"
              :rules="[chk_Name]"
              label="提醒內容"
              placeholder="ex:上班記得打卡哦"
            ></v-text-field>
            <v-select
              v-model="select"
              item-text="name"
              item-value="val"
              :items="selNotice"
              label="提醒方式"
              @change="selChange"
            ></v-select>
        
            <v-btn
                color="primary"
                :disabled="tripDisabled"
                depressed
                style="width: 100%;"
                @click="api_addTime"
              >
                <v-icon>mdi-plus-circle</v-icon>
                新增提醒點
              </v-btn>
            </v-col>
          </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      </div>

      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">
            提醒
          </v-card-title>
  
          <v-card-text>
            確定要刪除此打卡位置嗎?
            (刪除後將無法復原)
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
  
            <v-btn
              color="green darken-1"
              text
              @click="dialog=false"
            >
              取消
            </v-btn>
  
            <v-btn
              color="green darken-1"
              text
              @click="api_delTime"
            >
              確定
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <v-btn
          class="position-center"
          style="left: auto;top:auto;z-index: 99;"
          color="white"
          elevation="2"
          fab
        >
          <v-icon>mdi-menu</v-icon>
      </v-btn> -->
    </v-row>
  </v-container>
</template>

<script>
  Array.prototype.remove = function() {
      var what, a = arguments, L = a.length, ax;
      while (L && this.length) {
          what = a[--L];
          while ((ax = this.indexOf(what)) !== -1) {
              this.splice(ax, 1);
          }
      }
      return this;
  };
  import axios from 'axios';
  export default {
    name: 'App',
    props: ['baseURL','baseLINE','baseAPI','baseADMIN','tax'],
    components: {
    },
    data(){
      return{
        panel:[0],
        alertShow:true,
        alertType:"info",
        alert:"個人提醒 會發給有在群組內同事個人訊息",
        attr_icon:"mdi-dots-horizonta",
        str_groupid:"",
        groupName:"",
        timeName:"",
        pre_del:null,
        dialog:false,
        date: null,
        trip: {
          ip: '',
          message:"開始設定WIFI設備",
          name:'',
          location: null,
          start: null,
          end: null,
        },
        selNotice:[
          {name:'個人提醒',val:1},
          {name:'群組提醒',val:2},
          {name:'群組+個人提醒',val:3},
        ],
        select:1,
        tripDisabled:true,
        timePicker:false,
        btime:"00:00",
        ls_timeline:[
          {color:"red",notice:"12:00",title:"早上打卡要記得哦",subtitle:"群組提醒"}
        ],
      }
    },
    
    
    mounted() {
      this.$store.commit('SET_LAYOUT', "app-layout")
      let query = this.$route.query;
      this.str_groupid = query['Groupid'];
      this.api_getGroupInfo();
      //this.getWifi();
    },
    methods:{
      addz:function(num){
        return num<10?'0'+num:num;
      },
      random_color(){
        let colorStr="";
        //字串的每一字元的範圍
        let randomArr=['0','1','2','3','4','5','6','7','8','9','a','b','c','d','e','f'];
        //產生一個六位的字串
        for(let i=0;i<6;i++){
          //15是範圍上限，0是範圍下限，兩個函式保證產生出來的隨機數是整數
          colorStr+=randomArr[Math.ceil(Math.random()*(15-0)+0)];
        }
        return colorStr;
      },
      chk_Name(value){
        console.log("被檢測",value);
        if(value ==""){
          this.tripDisabled = true;
          return "請輸入打卡點名稱"
        }
        this.tripDisabled = false;
        this.alert = "記得按下新增打卡點保存位置哦!"
        this.alertType="info";
        return true;
      },
      selChange(){
        console.log(this.select)
      },
      api_getGroupInfo(){
        console.log("群組編號",this.str_groupid);
        if(this.str_groupid == null)return;
        axios
        .get(this.baseURL+'/api/Manage/strGroupRemindinfo?strGroupId='+this.str_groupid)
        .then((response)=>{
          
          let data = JSON.parse(JSON.parse(response.data));
          this.ls_timeline = [];
          for(let i in data){
            let newcolor = "#"+this.random_color();
            let _time = this.addz(data[i]["fTimehours"])+":"+this.addz(data[i]["fTimeminutes"]);
            let send = '';
            if(data[i]["fSend"] == "user"){
              send = "個人";
            }else{
              send = "群組"
            }
            let can_add = true;
            for(let x in this.ls_timeline){
              if(this.ls_timeline[x]["notice"] == _time && this.ls_timeline[x]["title"] == data[i]["fMessage"]){
                this.ls_timeline[x]["subtitle"] += ("+"+ send);
                this.ls_timeline[x]["fId"] = [this.ls_timeline[x]["fId"],data[i]["fId"]];
                can_add = false
              }
            }
            if(can_add == true){
              let _new = {fId:[data[i]["fId"]],color:newcolor,notice:_time,title:data[i]["fMessage"],subtitle:send}
              this.ls_timeline.push(_new);
            }
            
          }
          
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
          this.alert = "獲得資料失敗，請聯絡技術開發人員"
          this.alertType = "error";
        });
      },
      api_addTime(){
        let ary_time = this.btime.split(':');
        let hh = parseInt(ary_time[0]);
        let mm = parseInt(ary_time[1]);
        console.log(hh,mm,ary_time)
        axios
        .get(this.baseURL+'/api/Manage/setGroupRemind?GroupId='+ this.str_groupid +'&Timehours='+ hh +'&Timeminutes='+ mm +'&Message='+ this.timeName +'&Method='+this.select)
        .then((response)=>{
          if(response.data == true){
            this.alert = "新增成功，可以開始新增新的提醒"
            this.alertType = "success";
            this.api_getGroupInfo();
          }else{
            this.alert = "新增失敗，請聯絡技術開發人員"
            this.alertType = "error";
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
          this.alert = "新增失敗，請聯絡技術開發人員"
          this.alertType = "error";
        });
      },
      api_delTime(){
        let item = this.pre_del;
        this.dialog = false;
        for(let fid of item.fId){
          axios
          .get(this.baseURL+'/api/Manage/DeleteRemind?fid='+fid)
          .then((response)=>{
            let data = JSON.parse(JSON.parse(response.data));
            console.log(data[0]["status"])
            if(data[0]["status"] == "true"){
              this.alert = "刪除成功，可以開始新增新的標點"
              this.alertType = "success";
              this.api_getGroupInfo();
            }
          })
          .catch(function (error) { // 请求失败处理
            console.log(error);
            this.alert = "刪除失敗，請聯絡技術開發人員"
            this.alertType = "error";
          });
        }
        
      },
      getWifi(){
        this.trip.message = "獲取此WIFI設備資訊中.."
        axios
        .get('https://api.ipify.org?format=json')
        .then((response)=>{
          this.trip.message = "重新設定設備資訊"
          let ip =  response.data.ip;
          this.trip.ip = ip;
          this.tripShow = true;
        })
        .catch(function (error) { // 请求失败处理
          console.log("錯誤資訊",error);
          this.alertType = "error";
          this.alert = "獲取ip失敗，請檢查是否有連上網路";
        });
      },
      chk_del(item){
        this.dialog = true;
        this.pre_del = item;
      },
    },
  }
  </script>
  <style>
    .position-center{
      position: relative;
      margin: auto;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
    .margin-0-auto{
      margin: 0 auto;
    }
    @media (max-width: 991px) {
      .d-lg-column{
        display:flex;
        flex-direction: column-reverse;
      }
    }
  </style>